export default __webpack_public_path__ + "ab6ae3d18b9b3bc7aeb7e58fb2fb2b4a.png";